// @ts-check
import {any} from 'ramda'
import forgotCtrl from './forgot/forgot.ctrl'
import forgotTpl from './forgot/forgot.html'
import angular from 'angular';

import { Auth } from 'aws-amplify'
import { CognitoUser } from 'amazon-cognito-identity-js'
import mfaForm from './mfaForm.html';
import MfaFormController from './mfaFormController'
import './login.css'

const LOCALHOST = 'localhost';

class LoginController {
  /* @ngInject */
  constructor (Users, Auth, $state, $rootScope, $mdDialog, $mdToast, $window, $location, $cookies, $stateParams, $scope, branchData, segment, SegmentPixel) {
    this.$rootScope = $rootScope
    this.Users = Users
    this.Auth = Auth
    this.segment = segment
    this.getPixelUrl = SegmentPixel.getPixelUrl
    this.$window = $window
    this.$state = $state
    this.$mdDialog = $mdDialog
    // eslint-disable-next-line no-undef
    this.isLocal = CONFIG.IS_LOCAL
    // eslint-disable-next-line no-undef
    this.cookieDomain = CONFIG.COOKIE_DOMAIN
    this.invalidLoginMsg = 'Invalid email address or password.'
    this.errorMessages = [{
      type: 'user',
      text: this.invalidLoginMsg
    }, {
      type: 'password',
      text: this.invalidLoginMsg
    }]
    this.hideLogin = true;
    
    // If running web-angular locally with web-react NOT also running locally...
    // Show the old login page, so that developers can login to web-angular    
    if (this.$window.location.hostname === LOCALHOST) {
      this.hideLogin = CONFIG.REACT_APP_BASE.includes("localhost")
    }

    this.username = "" 
    this.password = ""

    // If user is un-authenticated, redirect to the react login page
    // After logging in web-react will place cognito tokens into cookies, 
    // under a shared domain which web-angular can access
    if (!Auth.loggedIn() && this.hideLogin){
      const redirectBaseUrl = window.location.origin; 
      const redirectUrlPath = this.$window.location.hostname === LOCALHOST ? "/app.html" : "";
      $window.location.href = `${CONFIG.REACT_APP_BASE}?redirectUrl=${redirectBaseUrl + redirectUrlPath}`
    }
  
    if (Auth.loggedIn()) {
      this.loggingIn = true
    }

    this.$mdToast = $mdToast
    this.$scope = $scope
    this.createForm = {}
    this.user = {}
    this.$mdToast = $mdToast

    this.validateField = (formFieldName) => {
      const field = this.createForm[formFieldName];
      field.$validate();

      if(!field.$valid) {
        Object.keys(field.$error).forEach(error => field.$setValidity(error, true));
      }
    }

    this.$cookies = $cookies
    if (this.$cookies.get('originalReferrer') || $window.document.referrer) {
      this.user.referrer = this.$cookies.get('originalReferrer') || $window.document.referrer
    }

    this.sourceSelect = false
    this.duplicateAccount = false
    this.outOfArea = false
    this.clientSignup = false

    if (branchData) {
      this.branchData = branchData
      this.user.branchParams = {}
      if (this.branchData.referrerCode) this.user.referrerCode = this.branchData.referrerCode
      if (this.branchData['~channel']) {
        this.user.source = this.branchData['~channel']
        this.user.branchParams.utmSource = this.branchData['~channel']
      }
      if (this.branchData['~campaign']) {
          this.user.branchParams.utmMedium = this.branchData['~campaign']
      }
      // if (this.branchData.campaignId) this.user.campaignId = this.branchData.campaignId
      // if (this.branchData.jobId) this.user.jobId = this.branchData.campaignId
      if (this.branchData.inviteCompanyType) {
        this.inviteCompanyType = this.branchData.inviteCompanyType
        this.createCompany()
      }
      if (this.branchData.pipelineId) {
        this.pipelineApplyId = this.branchData.pipelineId
      }
    }
    //  link to account creation page for worker or client
    this.pipelineApplyId = $stateParams.pipeline
    this.workerOrClient = $stateParams.create
    this.enteredEmail = $stateParams.email || null
    this.stageId = $stateParams.stageid || null
    this.jobId = $stateParams.jobid || null
    this.companyEOR = $stateParams.companyeor || null
    if (this.workerOrClient === 'worker') {
      if (this.enteredEmail) this.user.username = this.enteredEmail
      if (this.stageId) this.user.stageId = this.stageId
      if (this.jobId) this.user.jobId = this.jobId
      if (this.companyEOR) this.user.companyEOR = this.companyEOR
      this.createWorkerAccount()
    }
    if (this.workerOrClient === 'company') {
      this.createCompany()
    }

    $scope.imageUpload = (elem) => {
      const reader = new FileReader()
      reader.onload = $scope.imageIsLoaded
      reader.readAsDataURL(elem.files[0])
    }

    $scope.imageIsLoaded = (e) => {
      $scope.profilePic = e.target.result
      this.photoChosen = true
      this.editPhoto = false
      $scope.$apply()
    }

    $scope.togglePassword = function () { $scope.typePassword = !$scope.typePassword; };

    this.editPhoto = false
    this.photoChosen = false
    this.myCroppedImage = '' // in this variable you will have dataUrl of cropped area.
    this.verificationCode = null
  }

  createCompany () {
    this.user.signUps = 'Client'
    this.clientSignup = true
    this.user.verificationCode = ''
    if (!this.branchData.referrerCode) {
      //  try to get cookie
      var cookie = this.$cookies.get('referrerCode')
      if (cookie) {
        this.user.referrerCode = cookie
      }
    }
  }

  createWorkerAccount () {
    document.location.href = CONFIG.CM7_WEB_URL + '/account/register'
  }

  createIntercomLead () {
    this.$window.Intercom('showNewMessage', 'I Would like to Schedule an Account Exec Call\n')
  }

  redirect () {
    this.$rootScope.$broadcast('app:authenticated')
  }

  showErrorModal (message) {
    this.$mdDialog.show(
      this.$mdDialog.alert()
        .parent(angular.element(document.querySelector('body')))
        .clickOutsideToClose(true)
        .title('Login Error')
        .textContent(message)
        .ariaLabel('Login Error')
        .ok('Login Page')
    )
  }

  loginError (res) {
    // Random error, dialog it.
    this.$rootScope.$broadcast('app:loading:done')
    if (!any(x => x === res.data, Object.keys(this.errorMessages))) {}

    // Invalidate form inputs and display error message via ng-message.
    if (res.data.reason && (res.data.reason === 'INCORRECT_USERNAME' || res.data.reason === 'INCORRECT_PASSWORD')) {
      this.serverError = true
      this.loginForm.$error.invalidLogin = true
    } else {
      this.showErrorModal(res.data)
    }
  }

  async login () {
    this.serverError = false
    /** @type {CognitoUser?} */
    let cognitoUser = null
    try {
      cognitoUser = await Auth.signIn(this.username, this.password);
    } catch (e) {
      this.showErrorModal(e.message)
    }
    if (cognitoUser?.challengeName === "SMS_MFA") {
      this.openMfaModal(cognitoUser)
    }
    else {
      await this.handleSignIn()
    }
  }

  /**
   * This function is only called when developers are signing in to web-angular locally
   */
  async handleSignIn () {
    await this.Auth.retrieveLegacyTokens()
    this.$window.location.reload()
  }

  /**
   * 
   * @param {CognitoUser} cognitoUser 
   */
  openMfaModal (cognitoUser) {
    this.$mdDialog.show({
      parent: document.body,
      template: mfaForm,
      controller: MfaFormController,
      controllerAs: 'l',
      clickOutsideToClose: true,
      locals: {
        cognitoUser: cognitoUser,
        handleConfirmLogin: () => this.handleSignIn()
      }
    })
  }

  reset () {
    alert("To change your password, click \"Forgot Password\" from the login page of local copy or deployed version of web-react")
  }

  outOfAreaOpen () {
    const alert = this.$mdDialog.alert({
      title: 'We’re not in your area yet ',
      textContent: 'Looks like you’re a bit early for the worm. We’ll let you know when we launch in your area. To try a different ZIP code, go back',
      ok: 'Go Back'
    })
    this.$mdDialog.show(alert)
  }

  createCompanyAccount () {
    if (this.createForm.$invalid) {
      return
    }
    this.Auth.workerOrClientCreate(this.user)
      .then((response) => {
        let msg = ''
        if (response.reason) {
          if (response.reason.includes('ER_DUP_ENTRY')) {
            msg = 'Email is already in use for an account'
            this.createForm.username.$error = {duplicate: true}
          }
          if (response.reason === 'ER_CODE') {
            msg = 'The verification code you entered appears to be incorrect.'
            // this.createForm.$invalid = true
            this.createForm.verificationCode.$error = {invalid: true}
          }
        } else {
          msg = 'User Created'
        }
        // Redirect
        this.$mdToast.showSimple(msg)
        if (!response.reason) {
          let d = new Date()
          d.setMonth(d.getMonth() + 2)
          let cookieOptions = {'expires': d.toString()}
          if (!this.isLocal) cookieOptions.domain = this.cookieDomain
          if (this.user.signUps === 'Client') {
            this.$cookies.put(BEARER_TOKEN_NAME, response.authToken, cookieOptions)
            this.segment.track('fe_employer_account_created')
            this.$state.go('app.createCompany')
          }
        }
      })
      .catch((err) => {
        if (!err) return
        this.$mdToast.showSimple('Error creating profile check your Internet connection')
        console.log(err)
      })
  }

  uploadPicture () {
    var data = this.myCroppedImage.substring(this.myCroppedImage.indexOf(',') + 1)
    return this.Users.uploadProfilePic({
      profilePicture_base64: data
    })
    .then((res) => {
      const profilePicKey = 'profilePic'
      this.Users.updateMe(profilePicKey, res.data.url)
      this.photoChosen = false
      const msg = 'Profile Picture Uploaded!'
      this.$mdToast.showSimple(msg)
    })
    .catch((err) => {
      if (!err) return
      this.$mdToast.showSimple('Unable to Upload Profile Picture')
    })
  }
}

export default LoginController
